<template>
  <div
    :class="['image', value.shadow ? '-shadow' : '', value.highlighted ? '-highlighted' : '', value.bordered ? '-bordered' : '']"
  >
    <img
      :src="value.imageFile.url"
      :width="value.imageFile.width"
      :height="value.imageFile.height"
    >
  </div>
</template>

<script setup>
defineProps({
  value: {
    type: Object,
    required: true,
  },
});
</script>

<style lang="scss" scoped>
.image {
  width: 100%;
  display: flex;
  overflow: hidden;

  img {
    max-width: 100%;
    height: auto;
  }

  &.-shadow {
    img {
      border-radius: .4rem;
      box-shadow: rgb(38 50 56 / 10%) 0 0 0 1px, rgb(38 50 56 / 10%) 0 2px 4px;
    }
  }

  &.-highlighted {
    background: #faf5f0;

    img {
      margin-top: 4rem;
      margin-bottom: 4rem;
    }
  }

  &.-bordered {
    border: 1px solid $border-color;
    border-radius: .4rem;
  }
}

</style>
